import React from "react";
import {
  SimpleGrid,
  Heading,
  Button,
  Image,
  Center,
  Text,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Box,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import manicure from "../images/manicure.jpg";
import pedicure from "../images/pedicure.jpeg";
import lashes from "../images/lashes.jpg";

function SimpleService() {
  const navigate = useNavigate();

  return (
    <Box bg="pink.100" py={10} px={[5, 10]}>
      <SimpleGrid
        columns={[1, 2, 3]} // 1 column on mobile, 2 on tablet, 3 on larger screens
        spacing={6} // Adjust spacing between cards
      >
        {/* Manicure Card */}
        <Card
          textAlign="center"
          padding={["10px", "15px", "20px"]}
          width={["100%", "90%", "80%"]}
        >
          <CardHeader>
            <Image
              src={manicure}
              alt="manicure"
              borderRadius="full"
              boxSize={["80px", "100px", "100px"]} // Smaller image on mobile
              objectFit="cover"
              mx="auto"
              mb={["10px", "20px"]} // Adjust margin for mobile
            />
            <Heading size={["sm", "xl"]} fontFamily={"Sacramento"}>
              Manicure
            </Heading>
          </CardHeader>
          <CardBody>
            <Center>
              <Text
                fontWeight="100"
                fontFamily="Open Sans"
                width={["90%", "200px"]} // Full width on mobile, 200px on larger screens
                wordBreak="break-word"
              >
                Experience the ultimate in nail care with our luxurious manicure
                service. We deliver the most stylish nail design and
                professional care methods that protect your nails while bringing
                your nails a new healthy and fashionable look!
              </Text>
            </Center>
          </CardBody>
          <CardFooter justifyContent="center" alignItems="center">
            <Button
              bg="lightpink"
              _hover={{ bg: "pink" }}
              onClick={() => navigate("/services")}
              color="white"
              size={["sm", "md"]} // Smaller button on mobile
            >
              Read More
            </Button>
          </CardFooter>
        </Card>

        {/* Pedicure Card */}
        <Card
          textAlign="center"
          padding={["10px", "15px", "20px"]}
          width={["100%", "90%", "80%"]}
        >
          <CardHeader>
            <Image
              src={pedicure}
              alt="pedicure"
              borderRadius="full"
              boxSize={["80px", "100px", "100px"]}
              objectFit="cover"
              mx="auto"
              mb={["10px", "20px"]}
            />
            <Heading size={["sm", "xl"]} fontFamily={"Sacramento"}>
              Pedicure
            </Heading>
          </CardHeader>
          <CardBody>
            <Center>
              <Text
                fontWeight="100"
                fontFamily="Open Sans"
                width={["90%", "200px"]}
                wordBreak="break-word"
              >
                Indulge in our revitalizing pedicure service, designed to pamper
                your feet and enhance your well-being. Choose from a variety of
                polishes to complete your look, leaving your feet refreshed and
                beautiful.
              </Text>
            </Center>
          </CardBody>
          <CardFooter justifyContent="center" alignItems="center">
            <Button
              bg="lightpink"
              _hover={{ bg: "pink" }}
              onClick={() => navigate("/services")}
              color="white"
              size={["sm", "md"]}
            >
              Read More
            </Button>
          </CardFooter>
        </Card>

        {/* Lashes Card */}
        <Card
          textAlign="center"
          padding={["10px", "15px", "20px"]}
          width={["100%", "90%", "80%"]}
        >
          <CardHeader>
            <Image
              src={lashes}
              alt="lashes"
              borderRadius="full"
              boxSize={["80px", "100px", "100px"]}
              objectFit="cover"
              mx="auto"
              mb={["10px", "20px"]}
            />
            <Heading size={["sm", "xl"]} fontFamily={"Sacramento"}>
              Lashes
            </Heading>
          </CardHeader>
          <CardBody>
            <Center>
              <Text
                fontWeight="100"
                fontFamily="Open Sans"
                width={["90%", "200px"]}
                wordBreak="break-word"
              >
                Enhance your natural beauty with our luxurious extensions
                ranging from subtle to dramatic. Enjoy defined lashes that
                eliminate daily mascara, making your eyes pop with effortless
                elegance!
              </Text>
            </Center>
          </CardBody>
          <CardFooter justifyContent="center" alignItems="center">
            <Button
              bg="lightpink"
              _hover={{ bg: "pink" }}
              color="white"
              onClick={() => navigate("/services")}
              size={["sm", "md"]}
            >
              Read More
            </Button>
          </CardFooter>
        </Card>
      </SimpleGrid>
    </Box>
  );
}

export default SimpleService;
